import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import { Kube } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import KubeForm from './KubeForm.vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditKube',
  props: {
    kube: {}
  },
  setup(__props: any) {

    const props = __props;

    const form = useForm({
        name: props.kube.name,
        number: props.kube.number,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "update",
    form: _unref(form),
    route: _ctx.route('v2.kube.update', _ctx.kube.id),
    method: "patch",
    "query-key": [_unref(QueryKey).KUBE],
    title: "kube.edit"
  }, {
    default: _withCtx(() => [
      _createVNode(KubeForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})